import { useEffect } from 'react';
import { useRouteError } from 'react-router';

import { reportError } from '@perpay-web/utils/errorHandlers';

import { ErrorScreen } from './ErrorScreen';

const useReportError = () => {
    const error = useRouteError();

    useEffect(() => {
        const shouldReportError = window.STAGING || window.PRODUCTION;

        if (!shouldReportError) {
            return;
        }

        reportError(error);
    }, [error]);
};

export const RouteLevelErrorComponent = () => {
    const error = useRouteError();

    useReportError();

    return <ErrorScreen error={error as Error} />;
};

export const AppLevelErrorComponent = () => {
    const error = useRouteError();

    useReportError();

    return <ErrorScreen error={error as Error} />;
};
